export default __webpack_public_path__ + "static/media/grantThornton.f0a4ef77.jpg";